/** Short-form abbreviations / acronyms that must always render in uppercase in the UI. */
export const CAREPRO_ABBREVIATIONS = new Set<string>([
  "EMR",
  "PDC",
  "MHEA",
  "HIS",
  "HEXA",
  "PRC",
  "PDPC",
]);

export function isCareProAbbreviation(value: string): boolean {
  if (!value || typeof value !== "string") return false;
  const lettersOnly = value.replace(/[^a-zA-Z]/g, "");
  if (lettersOnly.length === 0) return false;
  return CAREPRO_ABBREVIATIONS.has(lettersOnly.toUpperCase());
}
